export default "__VITE_ASSET__jadL1aMc__"